// @flow

export const CastReceiverStyles = {
  playerStatus: (id: number) => ({
    color: 'red',
    fontSize: 20,
    position: 'absolute',
    top: id * 20 + 10,
    zIndex: 100,
  }),
  receiverUiStatus: {
    color: 'red',
    fontSize: 20,
    position: 'absolute',
    top: 10,
    right: 20,
    zIndex: 100,
  },

  austinStatus: (id: number) => ({
    color: 'red',
    fontSize: 20,
    position: 'absolute',
    top: id * 20 + 10,
    left: 30,
    zIndex: 100,
  }),
  playerWrapper: (showSplash: boolean) => () => ({
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    position: 'absolute',
    opacity: showSplash ? 0 : 1,
  }),
};

export const MetadataViewerStyles = {
  posterContainer: (opacity: number) => ({
    position: 'fixed',
    zIndex: 1,
    top: 0,
    width: '100%',
    height: '100%',
    opacity,
    backgroundColor: '#222324',
  }),
  poster: { width: '100%', height: '100%' },
  titleFull: {
    position: 'fixed',
    bottom: '15%',
    fontSize: '2.3em',
    zIndex: 1,
    left: 0,
    right: 0,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  subtitleFull: {
    position: 'fixed',
    bottom: '15%',
    fontSize: '1em',
    zIndex: 1,
    left: 0,
    right: 0,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  miniPoster: { width: 150, marginRight: 15, objectFit: 'contain', maxHeight: 100 },
  miniInfoContainer: (title: string, subtitle: ?string) => ({
    marginLeft: 18,
    position: 'fixed',
    bottom: title !== subtitle ? 44 : 24,
    zIndex: 1,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  }),
  title: { textAlign: 'left', margin: 0, fontSize: '2.3em' },
  subtitle: { textAlign: 'left', margin: 0, fontSize: '1em' },
};

export const SplashStyles = {
  label: {
    bottom: 40,
    position: 'absolute',
  },
};

export const StatusWidget = {
  container: { zIndex: 1 },
  status: { position: 'fixed', marginTop: 175, zIndex: 1 },
};
